import { Pipe, PipeTransform } from '@angular/core';
import { TranslateColumnPipe } from './translate-column.pipe';

@Pipe({
    name: 'translateColumns',
    pure: false,
    standalone: false
})
export class TranslateColumnsPipe implements PipeTransform {

  constructor(private readonly translateColumnPipe: TranslateColumnPipe) {
  }

  transform(value: string[], boardName: string): string[] {
    return value.map(c => this.translateColumnPipe.transform(c, boardName))
  }

}
